import { BaseModel } from './base.model'

import { Coordinate } from './coordinate.model'

export class RawDataLog extends BaseModel {
  createdAt: string
  imei: string
  ts: string
  priority: number
  gpsData: GPS
  ioData: string
  odometer: number
  movement: number
  ignition: number
  externalVoltage: number
  batteryVoltage: number
  batteryVoltagePercentage: number
  temperatureLevel: number

  constructor(src?: RawDataLog) {
    super(src)

    const coordinate = this.gpsData && this.gpsData.coordinates
    this.gpsData.coordinates =
      !!coordinate.lat && !!coordinate.lng ? { lat: +coordinate.lat, lng: +coordinate.lng, ts: coordinate.ts } : null
  }
}

export interface GPS {
  coordinates: Coordinate | null
  speed: number
  angle: number
}
